// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import RequestFormResourceViewModel from '../../../../viewModel/resource/RequestFormResourceViewModel';
import RequestFormResourceDTO from '../../dto/resource/RequestFormResourceDTO';

export default abstract class RequestFormResourceModel extends BaseModel<RequestFormResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  * @type {date-time}
  */
  get submissionDate() { return this.dto.submissionDate; }
  set submissionDate(value) { this.dto.submissionDate = value; }
  /**
  */
  get requestId() { return this.dto.requestId; }
  set requestId(value) { this.dto.requestId = value; }
  /**
  */
  get formType() { return this.dto.formType; }
  set formType(value) { this.dto.formType = value; }
  /**
  */
  get formSubType() { return this.dto.formSubType; }
  set formSubType(value) { this.dto.formSubType = value; }
  /**
  */
  get formSummaryType() { return this.dto.formSummaryType; }
  set formSummaryType(value) { this.dto.formSummaryType = value; }
  /**
  */
  get customerEmail() { return this.dto.customerEmail; }
  set customerEmail(value) { this.dto.customerEmail = value; }
  /**
  */
  get isCompleted() { return this.dto.isCompleted; }
  set isCompleted(value) { this.dto.isCompleted = value; }
  /**
  */
  get paymentType() { return this.dto.paymentType; }
  set paymentType(value) { this.dto.paymentType = value; }
  /**
  */
  get paymentTransactionId() { return this.dto.paymentTransactionId; }
  set paymentTransactionId(value) { this.dto.paymentTransactionId = value; }
  /**
  */
  get paymentState() { return this.dto.paymentState; }
  set paymentState(value) { this.dto.paymentState = value; }
  /**
  */
  get reminderState() { return this.dto.reminderState; }
  set reminderState(value) { this.dto.reminderState = value; }
  /**
  * @type {int32}
  */
  get integrationCallId() { return this.dto.integrationCallId; }
  set integrationCallId(value) { this.dto.integrationCallId = value; }
  /**
  */
  get requestObject() { return this.dto.requestObject; }
  set requestObject(value) { this.dto.requestObject = value; }
  /**
  * @type {date-time}
  */
  get reminderSentOn() { return this.dto.reminderSentOn; }
  set reminderSentOn(value) { this.dto.reminderSentOn = value; }
  /**
  */
  get paymentObject() { return this.dto.paymentObject; }
  set paymentObject(value) { this.dto.paymentObject = value; }
  /**
  * @type {int32}
  */
  get reminderIntegrationCallId() { return this.dto.reminderIntegrationCallId; }
  set reminderIntegrationCallId(value) { this.dto.reminderIntegrationCallId = value; }
  /**
  */
  get language() { return this.dto.language; }
  set language(value) { this.dto.language = value; }
  /**
  */
  get comment() { return this.dto.comment; }
  set comment(value) { this.dto.comment = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    this.dto.submissionDate = qs.submissiondate;
    this.dto.requestId = qs.requestid;
    this.dto.formType = qs.formtype;
    this.dto.formSubType = qs.formsubtype;
    this.dto.formSummaryType = qs.formsummarytype;
    this.dto.customerEmail = qs.customeremail;
    value = qs.isCompleted === 'true' ? true : qs.iscompleted;
    value = qs.isCompleted === 'false' ? false : undefined;
    this.dto.isCompleted = value;
    this.dto.paymentType = qs.paymenttype;
    this.dto.paymentTransactionId = qs.paymenttransactionid;
    this.dto.paymentState = qs.paymentstate;
    this.dto.reminderState = qs.reminderstate;
    value = Number.parseFloat(qs.integrationcallid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.integrationCallId = value;
    this.dto.requestObject = qs.requestobject;
    this.dto.reminderSentOn = qs.remindersenton;
    this.dto.paymentObject = qs.paymentobject;
    value = Number.parseFloat(qs.reminderintegrationcallid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.reminderIntegrationCallId = value;
    this.dto.language = qs.language;
    this.dto.comment = qs.comment;
  }
}
